import api from '../api/api';
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const mecanicosService = {


    obterTodos: async (params) => {
    try {
      const url = `${BASE_URL}/mecanicos`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter mecanicos:", error);
      throw new Error("Erro ao obter mecanicos.");
    }

  },

};
